import gql from 'graphql-tag';

export default gql`
  query fetchUpliftMerchandiseBanner {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        upliftMerchandiseBanner {
          image
          popupImage {
            image
            alternateText
          }
          mobilePopupImage {
            image
            alternateText
          }
        }
      }
    }
    settings {
      uplift {
        pages {
          pageName
          pageValue
        }
      }
    }
  }
`;
